import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  deleteFileRequest: ["leave_id", "children_id", "file_id"],
  deleteFileSuccess: ["Status"],
  deleteFileFailure: null,
  clearDeleteFileData: null,
});

export const DeleteFileTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  leave_id: null,
  children_id: null,
  fetching: null,
  success: null,
  error: null,
  Status: null,
  file_id: null,
});

export const DeleteFileSelectors = {
  getData: (state: any) => state.deleteFile.data,
  isFetching: (state: any) => state.deleteFile.fetching,
  isSuccess: (state: any) => state.deleteFile.success,
  hasError: (state: any) => state.deleteFile.error,
};

export const request = (state: any, { leave_id, children_id, file_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id: leave_id,
    children_id: children_id,
    file_id: file_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { Status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    Status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const clear = (state: any) => {
  return state.merge ? state.merge(INITIAL_STATE) : INITIAL_STATE;
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DELETE_FILE_REQUEST]: request,
  [Types.DELETE_FILE_SUCCESS]: success,
  [Types.DELETE_FILE_FAILURE]: failure,
  [Types.CLEAR_DELETE_FILE_DATA]: clear,
});
